import ApiService from '../api.services';

const ReasonService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/reason');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/reason/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        try {
            const data = {
                reason: form
            }
            const res = await ApiService.post('/api/reason', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            reason: form
        }
        try {
            const response = await ApiService.put(`/api/reason/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/reason/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ReasonService;

export { ReasonService };

